// @Angular
import { Inject, Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

// oidc-client
import { UserManager, UserManagerSettings, User, WebStorageStateStore } from 'oidc-client';
export { User };

// RxJS
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Store } from '@ngrx/store';

// Api
// import { getLocationOrigin } from '@api/utils/url-helpers';
import { getLocationOrigin } from '../../celine/utils/url-helpers';

// Threshold
import { HttpThresholdService } from '../services/http-threshold.service';
import { Experience } from '../models/experience';
import { getExperience } from '../store/store';

declare var window: any;

@Injectable()
export class FGWService {

    private _userManager: UserManager;
    private oidc: any;
    private tokenKey: string = 'authorizationData';
    private isLoggedIn: boolean;
    protected token: string;

    private apiPath: string = 'api/actions/'
    private basePath: string;
    private experiencesOB$: Observable<Experience[]>;
    private experiencesBS$: BehaviorSubject<Experience[]>;


    /**
     *
     * @param store
     * @param http
     */
    constructor (private store: Store<any>, private http: Http) {

        // Get oidc from the Window object
        this.oidc = window._oidc;

        // var settings = {
        //     client_id: JSON.parse(window['__CONFIGURATION'])['clientId'],
        //     redirect_uri: `${window.location.href}#`,
        //     response_type: JSON.parse(window['__CONFIGURATION'])['responseType'],
        //     scope: JSON.parse(window['__CONFIGURATION'])['scopes'],
        //     authority: JSON.parse(window['__CONFIGURATION'])['authUrl'],
        //     post_logout_redirect_uri: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''),
        //     silent_redirect_uri: location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '') + `/silent-renew.html`,
        //     automaticSilentRenew: true,
        //     accessTokenExpiringNotificationTime: 180,
        //     silentRequestTimeout: 60000,
        //     filterProtocolClaims: true,
        //     loadUserInfo: true,
        //     userStore: new WebStorageStateStore({ store: sessionStorage })
        // }

        // this._userManager = new UserManager(settings);

        // get base url
        this.basePath = getLocationOrigin();

        this.isLoggedIn = sessionStorage.getItem(this.tokenKey) ? true : false;
        this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;

        // Get experience from state
        this.experiencesOB$ = this.store.select(getExperience);
        this.experiencesOB$.subscribe((experience) => {
            // debugger;
            this.experiencesBS$ = new BehaviorSubject(experience);
        });

    }

    /**
     * Returns promise to load the User object for the currently authenticated user.
     * e.g. getUser().then(user =>
     *      {
     *          YOU HAVE USER NOW
     *      })
     *      .catch(err => console.log(err));;
     */
    // public getUser(): Promise<User> {
    //     return this._userManager.getUser();
    // }

    // public login(): Promise<void> {
    //     return this._userManager.signinRedirect();
    // }

    // public renewToken(): Promise<User> {
    //     return this._userManager.signinSilent();
    // }

    // public logout(): Promise<void> {
    //     return this._userManager.signoutRedirect();
    // }

    public getTheme() {
        let stylesheet = document.getElementById('theme') as HTMLLinkElement;
        let stylesheetArray = stylesheet.href.split('/');
        let stylesheetTheme = stylesheetArray[stylesheetArray.length - 1];
        return stylesheetTheme.substring(0, stylesheetTheme.indexOf('.'));
    }

    /**
     * Generic wrapper for tag retrieval from connected experience
     * @param experienceName Connected experience name
     * @param key Tag name
     */
    public getTag(experienceName: string, key: string) {
        let result = null;
        let experiences = this.experiencesBS$.getValue() as Experience[];
        if (experiences) {
            experiences.map((experience: Experience) => {
                if (experience.name == experienceName) {
                    if ((experience.tags) && (experience.tags.hasOwnProperty(key))) {
                        result = experience.tags[key];
                    }
                }
            });
        }

        // no match, lets try path
        if (experiences) {
            if (result == null) {
                experiences.map((experience: Experience) => {
                    if (experience.path == experienceName) {
                        if ((experience.tags) && (experience.tags.hasOwnProperty(key))) {
                            result = experience.tags[key];
                        }
                    }
                });
            }
        }

        return result;
    }

    /**
     *
     * @param url
     */
    public get(url: string): Observable<any> {
        return this.http.get(url)
    }

    /**
     *
     * @param url
     * @param body
     */
    public post(url: string, payload: any): Observable<any> {
        return this.http.post(url, JSON.stringify(payload))
    }

    /**
     * Wrapper to send API calls to Fabric Gateway
     * @param experienceName Connected experience name
     * @param action API action
     * @param payload API payload
     */
    public send(experienceName: string, action: string, payload: any, headers?: Headers): Observable<any> {
        let url = this.getAPIUrl(experienceName, action);
        let sendHeaders = this.getHeaders();
        const payloadJson = JSON.stringify(payload);

        this.isLoggedIn = sessionStorage.getItem(this.tokenKey) ? true : false;
        this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;

        if (headers) sendHeaders = headers;

        return this.http.post(url,
            { Payload: payloadJson },
            { headers: sendHeaders })
            .catch((error: Response) => {
                return Observable.throw(error)
            }
            )
    }

    /**
     *
     * @param experienceName
     * @param query
     */
    public getAPIUrl(experienceName: string, query: string) {
        let url: string;
        let ver: string;
        let experiences = this.experiencesBS$.getValue() as Experience[];
        experiences.map((experience: Experience) => {
            if (experience.name == experienceName) ver = experience.version
        });

        // no match, lets try path
        if (ver == null) {
            experiences.map((experience: Experience) => {
                if (experience.path == experienceName) ver = experience.version
            });
        }

        return `${this.basePath}${this.apiPath}${experienceName}/${ver}/${query}`
    }

    private getHeaders(): Headers {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('Cache-Control', 'no-cache=authorization, no-store, post-check=0, pre-check=0');
        headers.append('Pragma', 'no-cache');
        headers.append('Expires', '0');
        if (this.isLoggedIn) headers.set('Authorization', `Bearer ${sessionStorage.getItem(this.tokenKey)}`);
        return headers;
    }

    public getAssetsUrl(experienceName: string) {
        let experiences = this.experiencesBS$.getValue() as Experience[];
        let assetsUrl = '';

        experiences.map((experience: Experience) => {
            if (experience.name == experienceName) {
                assetsUrl = experience.moduleUrl.split('#')[0].replace('module.js', '');
            }
        });

        return assetsUrl
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/fgw.service.ts